import { Modal } from '../../../../../components/Modal/Modal'
import './UpdateMeetingTemplateModal.scss'

const LEARN_HOW_URL = 'https://help.zocks.io/en/articles/13531314-template-library-setting-up-templates'

export interface UpdateMeetingTemplateModalProps {
  show: boolean
  onHide: () => void
  onConfirm: () => void
  isLoading?: boolean
}

export const UpdateMeetingTemplateModal: React.FC<UpdateMeetingTemplateModalProps> = ({ show, onHide, onConfirm, isLoading = false }) => {
  const body = (
    <div className='update-meeting-template-modal__body'>
      <div className='update-meeting-template-modal__warning'>
        <i className='bi bi-exclamation-triangle-fill update-meeting-template-modal__warning-icon' />
        <span className='paragraph-medium update-meeting-template-modal__warning-text'>
          Manual edits will be lost. Copy anything you want to keep before continuing.
        </span>
      </div>
      <span className='paragraph-medium'>
        {`Legacy meeting types won't be available from the dropdown after rerunning the meeting prep. `}
        <a className='update-meeting-template-modal__learn-link' href={LEARN_HOW_URL} target='_blank' rel='noreferrer'>
          Learn how to recreate them
        </a>
      </span>
    </div>
  )

  return (
    <Modal
      className='update-meeting-template-modal'
      show={show}
      onHide={onHide}
      header={<span className='fs-5 fw-bold'>Update meeting?</span>}
      body={body}
      centered
      showFooterActions
      footerPrimaryActionTitle='Update Meeting'
      onFooterPrimaryAction={onConfirm}
      footerPrimaryActionLoading={isLoading}
      footerPrimaryActionDisabled={isLoading}
      footerSecondaryActionDisabled={isLoading}
    />
  )
}
